import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FlattenedSequence } from '@pixacare/dtos';
import { TuiItemsWithMore } from '@taiga-ui/kit';
import { MediaClickedOutput } from 'src/app/shared/models/media-clicked-output';
import { SequenceMediaComponent } from '../sequence-media/sequence-media.component';

@Component({
  selector: 'pxc-sequence-stacks-preview',
  templateUrl: './sequence-stacks-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiItemsWithMore, TranslocoDirective, SequenceMediaComponent],
})
export class SequenceStacksPreviewComponent {
  @Input() sequences: FlattenedSequence[];

  @Output() deleteMedia = new EventEmitter<MediaClickedOutput>();
  @Output() clickMore = new EventEmitter<void>();

  readonly displayedSequencePreviews = 6;

  getRemaining(index: number): number {
    const offset = index < this.displayedSequencePreviews ? index + 2 : index + 1;
    return this.sequences.length - offset;
  }

  deleteSequence(sequence: FlattenedSequence, event: Event): void {
    event.stopPropagation();
    this.deleteMedia.emit({
      mediaIdx: 0,
      sequenceId: sequence.sequenceInstance.id,
      clientCode: sequence.clientCode,
    });
  }
}
